// extracted by css-extract-rspack-plugin
module.exports =  {"primaryPanelHeader":"HasInsurances__primaryPanelHeader--_E3vk"};